export default "__VITE_ASSET__B_wCNR7b__"